import misRutas from 'vue-routes-generator'
import DescargarXFrameComponent from './App.vue'

export default {
	install: Vue => {
		misRutas.route('/main').child('descargar-xframe', {
			name: 'Descargar del XFrame',
			component: DescargarXFrameComponent
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/descargar-xframe/vue/index.js